import { pmFetchJson } from "@penmate/react-shared/api/pmFetch";

export type RawMessage = any;

export type MessagePage = {
  items: RawMessage[];
  nextCursor?: string | null;
  hasNextPage: boolean;
};

export async function fetchMessagesPage(args: {
  penmateId: string;
  cursor?: string;
}): Promise<MessagePage> {
  const res = await pmFetchJson<any>("/letters", {
    method: "GET",
    params: { penmate_id: args.penmateId, cursor: args.cursor },
  });

  const letters = (res && res.letters) || [];
  const emessages = (res && res.emessages) || [];

  const items = ([] as RawMessage[]).concat(letters, emessages).map((m: any) => {
    // Angular normalizes by copying `data` to top-level; do the same.
    const data = (m && m.data) || {};
    return { ...data, ...m };
  });

  return {
    items,
    nextCursor: (res && res.next_cursor) || null,
    hasNextPage: !!(res && res.has_next_page),
  };
}

